(() => {
  const PORTAL_ID = 'shopclips-video-react-portal';

  const strip = () => {
    const portal = document.getElementById(PORTAL_ID);
    if (!portal) return false;

    // Remove from the actual buttons (your original ask)
    portal.querySelectorAll('.v27-swiper-button-prev, .v27-swiper-button-next')
      .forEach(el => el.classList.remove('slider-arrow'));

    // Also remove from anything inside portal that has it (covers wrappers too)
    portal.querySelectorAll('.slider-arrow')
      .forEach(el => el.classList.remove('slider-arrow'));

    return true;
  };

  const burst = (ms = 500) => {
    const start = performance.now();
    const tick = () => {
      strip();
      if (performance.now() - start < ms) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  // 1) When portal is injected, burst-remove
  const bodyObserver = new MutationObserver(() => {
    if (document.getElementById(PORTAL_ID)) burst(500);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

})();